import type { InvoiceEmailListQueryParams } from './types';

import type { UUID } from '~/types/common';

export const queryKeysInvoiceEmail = {
  base: () => ['invoiceEmails'] as const,
  getDetail: (emailId: UUID) =>
    [...queryKeysInvoiceEmail.base(), 'detail', { emailId }] as const,
  getList: (queryParams: Partial<InvoiceEmailListQueryParams>) =>
    [...queryKeysInvoiceEmail.base(), 'list', queryParams] as const,
} as const;
